import { FaUserCircle } from "react-icons/fa";

export const CustomerInformationSection = ({ ticket }) => {
    return (
        <div className="p-4 rounded-xl" style={{ background: "rgba(15, 23, 42, 0.6)", border: "1px solid rgba(51, 65, 85, 0.2)" }}>
            <h4 className="text-sm font-bold text-gray-100 mb-3 flex items-center gap-2">
                <FaUserCircle className="text-ocean-400" /> Data Pelanggan
            </h4>
            <div className="space-y-2">
                <div className="flex justify-between">
                    <span className="text-xs text-slate-500">Nama</span>
                    <span className="text-sm text-slate-300 font-medium">{ticket?.name}</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-xs text-slate-500">Username PPPoE</span>
                    <span className="text-sm text-slate-300 font-mono">{ticket?.username}</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-xs text-slate-500">IP Address</span>
                    <span className="text-sm text-slate-300 font-mono">{ticket?.ip_address}</span>
                </div>
                <div>
                    <span className="text-xs text-slate-500 block mb-1">Alamat</span>
                    <span className="text-sm text-slate-400">{ticket?.address}</span>
                </div>
            </div>
        </div>
    );
};